import { useGeneradorPagina } from "../../../../pages/GeneradorPaginas/store";
import { NumberInput, SimpleErrorMessage } from "components/Inputs/inputs";
import moment from "moment";
import React, { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { SimpleContainer } from "components/Inputs/containers";
import Campos from "../Campos";
import { InputNumber } from "primereact/inputnumber";

const ID_ATTR = "UNIQUE_ID_FOR_INTERNAL_OPERATIONS";

/**
 *
 * @param {{campo:import("components/DynamicForm/typedefs").Campo}} props
 * @returns
 */
const TablaOptionsPercentage = ({ campo }) => {

  const [showModal, setShowModal] = useState(false);
  const { pageState } = useGeneradorPagina();
  const toggle = () => {
    methods.reset({
      [ID_ATTR]: null,
      name: pageState?.['policyFormData']?.value?.usuNombre || 'No Name'
    });
    setShowModal(!showModal);
  };

  const methods = useForm({ mode: "onChange" });

  const _onSubmit = (field) => (formData) => {
    Object.entries(formData).forEach(([key, value]) => {
      if (typeof value === 'object' && value instanceof Date) {
        formData[key] = moment(value).format('MM/DD/YYYY');
      }
      return true;
    })
    if (formData[ID_ATTR]) {
      field.value = field.value.filter(
        (item) => item[ID_ATTR] !== formData[ID_ATTR]
      );
      formData[ID_ATTR] = uuidv4();
      field.value.push(formData);
    } else {
      formData[ID_ATTR] = uuidv4();
      field.value.push(formData);
    }
    field.onChange(field.value);
    toggle();
  };

  const htmlMessage = (mssg) => {
    return (
      <div
        style={{
          // fontSize: "1rem",
          fontFamily: "Futura-Medium"
        }}
        dangerouslySetInnerHTML={{
          __html: mssg,
        }}
      />
    );
  };
  return (
    <Controller
      name={campo.name}
      defaultValue={[]}
      rules={campo.rules}
      render={({ field: { value, onChange, ref } }) => (
        <div className="col-12 my-5">
          <div className="d-flex mb-3">
            <div className="col-md-8 col-sm-12">
              {htmlMessage(campo.label)}

            </div>
          </div>
          <div className="w-100">
            <SimpleErrorMessage name={campo.name} />
          </div>

          <table className="table table-bordered">
            <thead>
              <tr>
                {campo?.options?.filter(o => o.value.tipo == 'columna').map((opcion) => {
                  return (
                    <th key={opcion.label}>{opcion.label}</th>

                  )

                })}



              </tr>
            </thead>
            <tbody>
              {campo?.options?.filter(o => o.value.tipo == 'fila').map((opcion) => {







                return (
                  <tr key={opcion.label}>
                    <th>{opcion.label}</th>
                    <FormProvider {...methods}>


                      {campo?.subCampos?.filter(c => c.name != opcion.value.value).map((subCampo) => {





                        let codigoOpcion = opcion.value.value.split('_').pop()
                        let codigoSubcampo = subCampo.name.split('_').pop()
                        let sub = []

                        sub.push(subCampo)



                        return (
                          codigoOpcion == codigoSubcampo ?
                            <td key={subCampo.name}>

                              <div className="row">
                                <div className="col-md-10">
                                  <SimpleContainer {...subCampo.containerProps}>


                                    <InputNumber
                                      className='input__mask__mex'
                                      value={value[subCampo.name]}
                                      onChange={(e) => {
                                        const valueAux = { ...value }
                                        valueAux[subCampo.name] = e.value


                                        onChange(valueAux);
                                      }}
                                      name={subCampo.name}
                                      style={{
                                        border: "none",
                                        outline: "none",
                                        fontFamily: "SourceSansPro-Regular",
                                      }}
                                      // mode="decimal"

                                      inputId={subCampo.name}

                                    />

                                  </SimpleContainer>
                                </div>
                                <div className="col-md-2">
                                  <br></br>
                                  <p>%</p>
                                </div>
                              </div>




                            </td>
                            : null
                        )

                      })}
                    </FormProvider>


                  </tr>

                )

              })}
            </tbody>
          </table>



        </div>
      )}
    />
  );
};

export default TablaOptionsPercentage;
